import { useModal } from '../../context/ModalContext';

/* STORE MODALS */
import CreateStoreModal from '../Modals/CreateStore/CreateStoreModal';
import DeleteStoreModal from '../Modals/DeleteStore/DeleteStoreModal';
import EditStoreModal from '../Modals/EditStore/EditStoreModal';

/* USERS MODALS */
import CreateUserModal from './CreateUser/CreateUserModal';
import EditUserModal from './EditUser/EditUserModal';
import DeleteUserModal from './DeleteUser/DeleteUserModal';

/* IMPORT SHEET MODALS */
import ImportModal from './Import/ImportModal';
import ImportSheetModal from './ImportSheet/ImportSheetModal';
import ExportSheetModal from './ExportSheet/ExportSheetModal';

/* IMPORT TEMPLATE MODAL */
import ImportTemplateListModal from './ImportTemplateList/ImportTemplateListModal';
import ViewImportTemplateModal from './ViewImportTemplate/ViewImportTemplateModal';
import EditImportTemplateModal from './EditImportTemplate/EditImportTemplateModal';
import DeleteImportTemplateModal from './DeleteImportTemplate/DeleteImportTemplateModal';

/* PRODUCT MODALS */
import CreateProductModal from '../Modals/CreateProduct/CreateProductModal';
import DeleteProductModal from '../Modals/DeleteProduct/DeleteProductModal';
import EditProductModal from '../Modals/EditProduct/EditProductModal';

/* EXPIRED PRODUCT MODALS */
import EditExpiredProductModal from '../Modals/EditExpiredProduct/EditExpiredProductModal';
import DeleteExpiredProductModal from '../Modals/DeleteExpiredProduct/DeleteExpiredProductModal';

/* FILTER ITEMS MODALS */
import FilterModal from '../Modals/Filter/FilterModal';
import TransferModal from '../Modals/Transfer/TransferModal';

/* EXPORT PDF MODAL */
import ExportPdfModal from '../Modals/ExportPdf/ExportPdfModal';

/* CLIENT MODALS */
import CreateClientModal from '../Modals/CreateClient/CreateClientModal';
import DeleteClientModal from '../Modals/DeleteClient/DeleteClientModal';
import EditClientModal from '../Modals/EditClient/EditClientModal';

/* USERS ADMIN MODALS */
import CreateAdminUserModal from './CreateAdminUser/CreateAdminUserModal';
import EditAdminUserModal from './EditAdminUser/EditAdminUserModal';
import DeleteAdminUserModal from './DeleteAdminUser/DeleteAdminUserModal';


const ModalManager = () => {

  const { 
    showCreateStoreModal, 
    closeCreateStoreModal,

    showDeleteStoreModal,
    closeDeleteStoreModal,

    showEditStoreModal,
    closeEditStoreModal,

    showCreateUserModal,
    closeCreateUserModal,

    showDeleteUserModal,
    closeDeleteUserModal,

    showEditUserModal,
    closeEditUserModal,

    showImportModal,
    closeImportModal,

    showImportSheetModal,
    closeImportSheetModal,

    showExportSheetModal,
    closeExportSheetModal,

    showImportListModal,
    closeImportListModal,

    showViewImportTemplateModal,
    closeViewImportTemplateModal,

    showEditImportTemplateModal,
    closeEditImportTemplateModal,

    showDeleteImportTemplateModal,
    closeDeleteImportTemplateModal,

    showCreateProductModal, 
    closeCreateProductModal,

    showDeleteProductModal,
    closeDeleteProductModal,

    showEditProductModal,
    closeEditProductModal,

    showEditExpiredProductModal,
    closeEditExpiredProductModal,

    showDeleteExpiredProductModal,
    closeDeleteExpiredProductModal,

    showFilterModal,
    closeFilterModal,

    showTransferModal,
    closeTransferModal,

    showExportPdfModal,
    closeExportPdfModal,

    showCreateClientModal, 
    closeCreateClientModal,

    showDeleteClientModal,
    closeDeleteClientModal,

    showEditClientModal,
    closeEditClientModal,
    
    showCreateAdminUserModal,
    closeCreateAdminUserModal,

    showDeleteAdminUserModal,
    closeDeleteAdminUserModal,

    showEditAdminUserModal,
    closeEditAdminUserModal,

   } = useModal();

  return (
    <>
      { showCreateStoreModal && <CreateStoreModal closeModal={ closeCreateStoreModal } />}
      { showDeleteStoreModal && <DeleteStoreModal closeModal={ closeDeleteStoreModal } />}
      { showEditStoreModal && <EditStoreModal closeModal={ closeEditStoreModal } />}

      { showCreateUserModal && <CreateUserModal closeModal={ closeCreateUserModal } />}
      { showDeleteUserModal && <DeleteUserModal closeModal={ closeDeleteUserModal } />}
      { showEditUserModal && <EditUserModal closeModal={ closeEditUserModal } />}

      { showImportModal && <ImportModal closeModal={ closeImportModal } />}
      { showImportSheetModal && <ImportSheetModal closeModal={ closeImportSheetModal } />}
      { showExportSheetModal && <ExportSheetModal closeModal={ closeExportSheetModal } />}
      { showImportListModal && <ImportTemplateListModal closeModal={ closeImportListModal } />}
      { showViewImportTemplateModal && <ViewImportTemplateModal closeModal={ closeViewImportTemplateModal } />}
      { showEditImportTemplateModal && <EditImportTemplateModal closeModal={ closeEditImportTemplateModal } />}
      { showDeleteImportTemplateModal && <DeleteImportTemplateModal closeModal={ closeDeleteImportTemplateModal } />}

      { showCreateProductModal && <CreateProductModal closeModal={ closeCreateProductModal } />}
      { showDeleteProductModal && <DeleteProductModal closeModal={ closeDeleteProductModal } />}
      { showEditProductModal && <EditProductModal closeModal={ closeEditProductModal } />}

      { showEditExpiredProductModal && <EditExpiredProductModal closeModal={ closeEditExpiredProductModal } />}
      { showDeleteExpiredProductModal && <DeleteExpiredProductModal closeModal={ closeDeleteExpiredProductModal } />}

      { showFilterModal && <FilterModal closeModal={ closeFilterModal } /> } 
      { showTransferModal && <TransferModal closeModal={ closeTransferModal } /> } 

      { showExportPdfModal && <ExportPdfModal closeModal={ closeExportPdfModal } /> } 

      { showCreateClientModal && <CreateClientModal closeModal={ closeCreateClientModal } />}
      { showDeleteClientModal && <DeleteClientModal closeModal={ closeDeleteClientModal } />}
      { showEditClientModal && <EditClientModal closeModal={ closeEditClientModal } />}
      
      { showCreateAdminUserModal && <CreateAdminUserModal closeModal={ closeCreateAdminUserModal } />}
      { showDeleteAdminUserModal && <DeleteAdminUserModal closeModal={ closeDeleteAdminUserModal } />}
      { showEditAdminUserModal && <EditAdminUserModal closeModal={ closeEditAdminUserModal } />}
    </>
  );
};

export default ModalManager;
